import { BaseToastProps, ToastService } from '@philips-internal/oswald-ui-components';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

class PendingExamCollectionToastHandler {
  static showToast(message: string, level: ToastLevel): void {
    const toast: BaseToastProps = {
      dismissible: true,
      highlight: false,
      id: '1',
      level: level,
      message: MessageService.translate(message),
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    };
    ToastService.open(toast);
  }
  static showInvalidCollectionTimeError(barcode: string): void {
    const defaultMessage = MessageService.translate('tws.pending-exam-collection.invalid-collection-time-error');
    const errorMessage = defaultMessage.replace('#@ETIQUETA#@', barcode);
    PendingExamCollectionToastHandler.showErrorToast(errorMessage);
  }

  static showBarcodeNotInPrescriptionErrorToast(prescriptionId: string | number): void {
    const defaultMessage = MessageService.translate('tws.pending-exam-collection.barcode-not-in-prescription-error');
    const errorMessage = defaultMessage.replace('#@NR_PRESCRICAO#@', String(prescriptionId));
    PendingExamCollectionToastHandler.showErrorToast(errorMessage);
  }

  static showExamCollectionFailErrorToast(examDescriptionList: string[], paramUseLaboratorySampleStandard: string): void {
    if(paramUseLaboratorySampleStandard === 'S') {
      const defaultMessage = MessageService.translate('tws.pending-exam-collection.exam-collection-fail');
      const examDescriptionListStr = '\n' + examDescriptionList.join('\n');

      PendingExamCollectionToastHandler.showErrorToast(defaultMessage + examDescriptionListStr);
    } else {
      PendingExamCollectionToastHandler.showErrorToast('tws.pending-exam-collection.change-exam-status-fail');
    }
  }

  static showSuccessToast(succesMessage: string): void {
    const toastId = 'exam-collection-success-toast:' + succesMessage;
    ToastService.close(toastId);
    ToastService.open({
      dismissible: true,
      id: toastId,
      level: ToastLevel.SUCCESS,
      message: MessageService.translate(succesMessage),
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000
    });
  }

  static showErrorToast(errorMessage: string): void {
    const toastId = 'invalid-barcode-error-toast:' + errorMessage;
    ToastService.close(toastId);
    ToastService.open({
      dismissible: true,
      id: toastId,
      level: ToastLevel.ERROR,
      message: MessageService.translate(errorMessage),
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000
    });
  }
}

export default PendingExamCollectionToastHandler;